import { Injectable, signal } from '@angular/core';
import { MasterdataCostCenter } from '@softapps/core/masterdata';

@Injectable()
export class ItemPropertyPrefillService {
  readonly carryOverText = signal(false);
  readonly carryOverCostCenter = signal(false);
  readonly lastText = signal('');
  readonly lastCostCenter = signal<MasterdataCostCenter | null>(null);
}
